import style from '../style/components/child-client-privacy-policy.module.scss'

interface ChildChildClientPrivacyPolicyProps {
  data: PrivacyPolicy.listPrivacy
}

const ChildClientPrivacyPolicy = ({ data }: ChildChildClientPrivacyPolicyProps) => {
  return (
    <main className={style.main}>
      <div className={style.title}>{data.title}</div>
      <ul className={style['list-wrapper']}>
        {data.content.map((item, idx) =>
          item.isList
            ? (
              <li key={idx} className={style.list}>
                {item.text}
              </li>
            )
            : (
              <div key={idx} className={style.paragraph}>
                {item.text}
              </div>
            ),
        )}
      </ul>
    </main>
  )
}

export default ChildClientPrivacyPolicy
